export const environment = {
	production: true,
	environmentName: 'prod',
	environmentNameVerbose: 'prod_VERBOSE',
	muleExperienceBaseURI: 'https://web-api.eqbank.ca/web/v1.1',
	muleExperienceOnboardingApi: '/onboarding/v2',
	muleExperienceAppID: '2f8db5bdd507422fb3b1a60494bb1244',
	muleExperienceAppPassword: '7B4c8848098c4dE1ADB508D73ab2218C',
	canadaPostApiKey: 'NJ21-GX97-HZ77-WB33',
	canadaPostScriptURI: 'https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js',
	canadaPostCssURI: 'https://ws1.postescanada-canadapost.ca/css/addresscomplete-2.30.min.css',
	oAuthURI: 'https://api.eqbank.ca',
	oAuthApi: 'auth/v1',
	loginUrl: 'https://web-public-api.eqbank.ca',
	userApi: 'https://api-oauthsecurity-gateway-qa2.istio.qa.eqb-int.cloud/auth/v2/auth',
	harnessApiKey: '82762809-c444-4871-9303-508c926b8cb9' ,
	trulioDocUploadURI: 'https://launch-workflow.trulioo.com/679bd2503df65e0e6818e7dc'
};
